const id = {
  shopifyTitle: "Shopify",
  shopifyAutomatedTextSetting: "Pengaturan Pesan Otomatis",
  shopifyReport: "Report",
  shopifyStoreConfiguration: "Konfigurasi Toko",
  shopifyConfigurationStoreHeader: "Akun Shopify",
  shopifyTableAccountName: "Nama Akun",
  shopifyTableStatus: "Status",
  shopifyTableAppStatus: "Subscription",
  shopifyTableAction: "Aksi",
  shopifyTableNoDataHeader: "Belum ada toko terhubung",
  shopifyTableNoDataDescription:
    "Hubungkan akun Shopify agar bisa mengirimkan pesan Whatsapp otomatis untuk informasi seputar pesanan kepada pelanggan.",
  shopifyButtonConnectStore: "Hubungkan Toko",
  shopifyFormUrlPlaceHolder: "Masukkan URL admin shopify kamu",
  shopifyFormUrlRequiredErrorMessage: "URL shopify wajib diisi",
  shopifyFormConnectButtonText: "Hubungkan",
  shopifyBannerInfo:
    "Akun toko Shopify belum tersambung, sambungkan melalui konfigurasi toko",
  shopifyConnectFormSuccessSnackbar: "Berhasil menghubungkan akun {0}",
  shopifyConnectFormErrorInvalidNameSnackbar:
    "Gagal menghubungkan akun. Cek lagi username atau URL akun kamu untuk menghubungkan",
  shopifyConnectFormErrorGeneralSnackbar:
    "Terjadi kesalahan, silakan coba lagi",
  shopifyConnectFormErrorInvalidToken:
    "Gagal menghubungkan akun, token invalid. Silakan coba lagi",
  shopifyConnectInstructionFirst:
    "Login ke akun admin Shopify melalui url <a class='font-weight-bold' target='_blank' href='https://admin.shopify.com'>https://admin.shopify.com/<a>.",
  shopifyConnectInstructionSecond:
    "Setelah berhasil login, silahkan copy url toko pada halaman browser. Contoh URL toko: <b>admin.shopify.com/store/(nama toko)</b> dan sambungkan di Koala+.",
  shopifyConnectDialogTitle: "Hubungkan akun Shopify",
  shopifyConnectFormUrlTitle: "URL admin Shopify",
  shopifyHowToConnectUrl: "Bagaimana cara mengetahui url halaman Shopify?",
  shopifyFormDialogFooter:
    "Koala+ menggunakan API resmi platform terkait, sehingga datamu terjamin 100% aman.",
  shopifyToggleButtonDisabledTooltip:
    "Tidak bisa mengaktifkan fitur. Hubungkan toko terlebih dahulu",
  shopifyToggleButtonDisabledTooltipAppSubscribe:
    "Tidak bisa mengaktifkan fitur. Silakan berlangganan add-on shopify",
  shopifyToggleButtonNonActiveTooltip: "Nonaktifkan {0}",
  shopifyToggleButtonActiveTooltip: "Aktifkan {0}",
  shopifyStatusActive: "Aktif",
  shopifyStatusNonActive: "Non aktif",
  shopifySeeDetail: "Lihat detail",
  shopifyAutomaticMessageMessageConfirmedTitle:
    "Pesanan selesai / Telah terkonfirmasi",
  shopifyAutomaticMessageMessageConfirmedDescription:
    "Kirim pesan otomatis whatsapp kepada pelanggan segera setelah pelanggan melakukan pembelian ditoko.",
  shopifyAutomaticMessageOrderCreatedTitle: "Pesanan dibuat",
  shopifyAutomaticMessageOrderCreatedDescription:
    "Kirim pesan otomatis whatsapp kepada pelanggan segera setelah pelanggan membuat pesanan baru di toko kamu.",
  shopifyAutomaticMessageOrderSentWithTrackerCourierTitle:
    "Pesanan dikirim menggunakan pelacakan kurir",
  shopifyAutomaticMessageOrderSentWithTrackerCourierDescription:
    "Kirim pesan otomatis whatsapp kepada pelanggan segera jika pesanan sudah dalam proses pengiriman melalui kurir.",
  shopifyAutomaticMessageRefundTitle: "Pesan notifikasi refund",
  shopifyAutomaticMessageRefundDescription:
    "Kirim pesan otomatis whatsapp kepada pelanggan yang mengajukan refund.",
  shopifyFormActivate: "Aktifkan",
  shopifyFormNonActivate: "Non-aktifkan",
  shopifyFormSelectTemplatePlaceholder: "Pilih template",
  shopifyFormErrorReqiuredSelectTemplate: "Wajib pilih template",
  shopifyUpdateActivateWebhookSuccessSnackbar: "Berhasil mengaktifkan template",
  shopifyUpdateNonActivateWebhookSuccessSnackbar:
    "Berhasil menonaktifkan template",
  shopifyDeleteConfigSuccessSnackbar: "Berhasil menghapus akun",
  shopifyDeleteConfigFailedSnackbar: "Gagal menghapus akun",
  shopifyDeleteDialogDescription:
    "Jika akun dihapus, pesan notifikasi Shopify akan berhenti.",
  shopifyStatusPending: "Menunggu",
  shopifyStatusUninstalled: "Tidak terhubung",
  shopifyStatusConnected: "Terhubung",
  shopifyGetTemplateFailedSnackbar:
    "Gagal mendapatkan template. Silakan coba lagi.",
  shopifyAddonsSubscriptionBanner:
    "Tambahkan adds on Shopify untuk menggunakan fitur ini.",
  shopifyActivateAddonsText: "Aktifkan Shopify",
  shopifySubscriptionAppStatusPro: "Pro",
  shopifySubscriptionAppStatusFree: "Gratis",
  shopifyConfigurationDeleteDialogTitle: "Lanjut hapus sambungan akun Shopify?",
  shopifyConfigurationDeleteDialogDescription:
    "Setelah konfigurasi akun Shopify dihapus, langganan app di Shopify akan dibatalkan juga.",
  shopifyDomainSignUpHint:
    "Nama Toko Shopify Tidak dapat diubah setelah registrasi",
  shopifySignUpProcessRequestOtp: "Memvalidasi email Anda...",
  shopifySignUpProcessVerifyOtp: "Memverifikasi email Anda...",
  shopifySignUpProcessRegisterKoala: "Mendaftarkan akun Anda...",
  shopifySignUpProcessRegisterKoalaPlus: "Mendaftarkan akun Anda...",
  shopifySignUpProcessRegisterProductCatalog: "Membuat toko Anda...",
  shopifySignUpProcessRegisterProductCatalogName: "Mendaftarkan toko Anda...",
  shopifySignUpProcessRegisterRoleShopify: "Buat akses baru Anda...",
  shopifySignUpProcessAssignRoleShopify: "Tetapkan akses baru Anda...",
  shopifySignUpProcessRegisterShopify: "Menghubungkan ke Shopify...",
  shopifySignUpProcessRedirectToShopify: "Mengarahkan ke Shopify...",
  shopifySignUpProcessDefaultProgress: "Memproses akun Anda...",
  shopifySignUpProcessFailed:
    "Terjadi kesalahan saat membuat akun Anda. Silakan menghubungi support@koalaapp.id untuk bantuan.",
  shopifyDedicatedWabaBannerTitle:
    "Pesan Otomatis akan dikirim melalui Whatsapp Koala Info",
  shopifyDedicatedWabaBannerContent:
    "Setiap pesan keluar menggunakan whatsapp Koala Info. Untuk upgrade akun kamu, silahkan menghubungi tim Koala atau kunjungi info disini untuk informasi lebih lanjut.",
  shopifyDedicatedWabaBannerLink: "Cek info lebih lanjut",
};

const en = {
  shopifyTitle: "Shopify",
  shopifyAutomatedTextSetting: "Automatic Message Setting",
  shopifyReport: "Report",
  shopifyStoreConfiguration: "Store Configuration",
  shopifyConfigurationStoreHeader: "Shopify Account",
  shopifyTableAccountName: "Account Name",
  shopifyTableStatus: "Status",
  shopifyTableAppStatus: "Subscription",
  shopifyTableAction: "Action",
  shopifyTableNoDataHeader: "There is no connected store yet",
  shopifyTableNoDataDescription:
    "Connect your Shopify account so you can send automatic WhatsApp messages for information about orders to customers.",
  shopifyFormUrlPlaceHolder: "Enter your Shopify admin URL",
  shopifyFormUrlRequiredErrorMessage: "Shopify URL is required",
  shopifyFormConnectButtonText: "Connect",
  shopifyBannerInfo:
    "Shopify account is not yet connected, connect via store configuration",
  shopifyButtonConnectStore: "Connect with Shopify",
  shopifyConnectFormSuccessSnackbar: "Account {0} is connected successfully",
  shopifyConnectFormErrorInvalidNameSnackbar:
    "Failed to connect account. Check your username or store URL again to connect",
  shopifyConnectFormErrorGeneralSnackbar:
    "Something went wrong. Please try again.",
  shopifyConnectFormErrorInvalidToken:
    "Failed to connect account, invalid token. Please try again.",
  shopifyConnectInstructionFirst:
    "Login to Shopify admin account via url <a class='font-weight-bold' target='_blank' href='https://admin.shopify.com'>https://admin.shopify.com/<a>.",
  shopifyConnectInstructionSecond:
    "After successfully logging in, please copy the store's URL on the browser page. Example store's URL: <b>admin.shopify.com/store/(store name)</b> and connect it in Koala+.",
  shopifyConnectDialogTitle: "Connect your Shopify Account",
  shopifyConnectFormUrlTitle: "Shopify admin's URL",
  shopifyHowToConnectUrl: "How to get Shopify page url?",
  shopifyFormDialogFooter:
    "Koala+ uses the official API of the relevant platform, so your data is 100% securely protected.",
  shopifyToggleButtonDisabledTooltip:
    "Feature can't be activate. Connect the store first",
  shopifyToggleButtonDisabledTooltipAppSubscribe:
    "Feature can't be activate. Please subscribe to shopify add-on",
  shopifyToggleButtonNonActiveTooltip: "Disable {0}",
  shopifyToggleButtonActiveTooltip: "Enable {0}",
  shopifyStatusActive: "Active",
  shopifyStatusNonActive: "Non active",
  shopifySeeDetail: "See detail",
  shopifyAutomaticMessageMessageConfirmedTitle: "Order completed / Confirmed",
  shopifyAutomaticMessageMessageConfirmedDescription:
    "Send automatic WhatsApp messages to customers as soon as the customer makes a purchase at the store.",
  shopifyAutomaticMessageOrderCreatedTitle: "Order created",
  shopifyAutomaticMessageOrderCreatedDescription:
    "Send automatic WhatsApp messages to customers as soon as the customer makes a new order at your store.",
  shopifyAutomaticMessageOrderSentWithTrackerCourierTitle:
    "Orders are shipped using courier tracking",
  shopifyAutomaticMessageOrderSentWithTrackerCourierDescription:
    "Send an automatic WhatsApp message to the customer immediately if the order is in the process of being sent via courier.",
  shopifyAutomaticMessageRefundTitle: "Refund notification",
  shopifyAutomaticMessageRefundDescription:
    "Send an automatic WhatsApp message to the customer who applies for a refund.",
  shopifyFormActivate: "Activate",
  shopifyFormNonActivate: "Non-activate",
  shopifyFormSelectTemplatePlaceholder: "Select template",
  shopifyFormErrorReqiuredSelectTemplate: "Template is required",
  shopifyUpdateActivateWebhookSuccessSnackbar:
    "Template activated successfully",
  shopifyUpdateNonActivateWebhookSuccessSnackbar:
    "Template non-activated successfully",
  shopifyDeleteConfigSuccessSnackbar: "Account successfully removed",
  shopifyDeleteConfigFailedSnackbar: "Failed to delete account",
  shopifyDeleteDialogDescription:
    "If account deleted, the automation notification Shopify will be disable.",
  shopifyStatusPending: "Pending",
  shopifySubscriptionAppStatusPro: "Pro",
  shopifySubscriptionAppStatusFree: "Free",
  shopifyStatusUninstalled: "Disconnected",
  shopifyStatusConnected: "Connected",
  shopifyGetTemplateFailedSnackbar:
    "Failed to get template list. Please try again.",
  shopifyAddonsSubscriptionBanner:
    "Unlock this feature by adding the Shopify add-on.",
  shopifyActivateAddonsText: "Activate Shopify",
  shopifyConfigurationDeleteDialogTitle: "Continue to delete Shopify account?",
  shopifyConfigurationDeleteDialogDescription:
    "Once the Shopify account configuration is deleted, app subscription on Shopify will be canceled",
  shopifyDomainSignUpHint:
    "Shopify Shop Name Can't be changed after registration",
  shopifySignUpProcessRequestOtp: "Validating your email...",
  shopifySignUpProcessVerifyOtp: "Verifying your email...",
  shopifySignUpProcessRegisterKoala: "Registering your account...",
  shopifySignUpProcessRegisterKoalaPlus: "Registering your account...",
  shopifySignUpProcessRegisterProductCatalog: "Creating your shop...",
  shopifySignUpProcessRegisterProductCatalogName: "Registering your shop...",
  shopifySignUpProcessRegisterRoleShopify: "Create your new role...",
  shopifySignUpProcessAssignRoleShopify: "Assign your new role...",
  shopifySignUpProcessRegisterShopify: "Connecting to Shopify...",
  shopifySignUpProcessRedirectToShopify: "Redirecting to Shopify...",
  shopifySignUpProcessDefaultProgress: "Processing your account...",
  shopifySignUpProcessFailed:
    "There was an error while creating your account. Please contact support@koalaapp.id for help.",
  shopifyDedicatedWabaBannerTitle:
    "Automatic Message will be sent via Whatsapp Koala Info",
  shopifyDedicatedWabaBannerContent:
    "Every outgoing message uses WhatsApp Koala Info. To upgrade your account, please contact the Koala team or visit info here for more information.",
  shopifyDedicatedWabaBannerLink: "Check for more info",
};

export default { id, en };
